export const FETCH_FRIENDS = 'FETCH_FRIENDS'
export const FETCH_FRIENDS_LOADING = 'FETCH_FRIENDS_LOADING'
export const FETCH_FRIENDS_ERROR = 'FETCH_FRIENDS_ERROR'
export const FETCH_FRIENDS_SUCCESS = 'FETCH_FRIENDS_SUCCESS'

export const FETCH_MORE_FRIENDS = 'FETCH_MORE_FRIENDS'
export const FETCH_MORE_FRIENDS_LOADING = 'FETCH_MORE_FRIENDS_LOADING'
export const FETCH_MORE_FRIENDS_ERROR = 'FETCH_MORE_FRIENDS_ERROR'
export const FETCH_MORE_FRIENDS_SUCCESS = 'FETCH_MORE_FRIENDS_SUCCESS'

export const FETCH_FRIEND_REQUESTS = 'FETCH_FRIEND_REQUESTS'
export const FETCH_FRIEND_REQUESTS_LOADING = 'FETCH_FRIEND_REQUESTS_LOADING'
export const FETCH_FRIEND_REQUESTS_ERROR = 'FETCH_FRIEND_REQUESTS_ERROR'
export const FETCH_FRIEND_REQUESTS_SUCCESS = 'FETCH_FRIEND_REQUESTS_SUCCESS'

export const ACCEPT_FRIEND_REQUEST = 'ACCEPT_FRIEND_REQUEST'
export const ACCEPT_FRIEND_REQUEST_LOADING = 'ACCEPT_FRIEND_REQUEST_LOADING'
export const ACCEPT_FRIEND_REQUEST_ERROR = 'ACCEPT_FRIEND_REQUEST_ERROR'
export const ACCEPT_FRIEND_REQUEST_SUCCESS = 'ACCEPT_FRIEND_REQUEST_SUCCESS'

export const INITIATE_UNFRIEND_CONFIRMATION = 'INITIATE_UNFRIEND_CONFIRMATION'
export const CANCEL_UNFRIEND_CONFIRMATION = 'CANCEL_UNFRIEND_CONFIRMATION'

export const REMOVE_OR_DENY_FRIEND = 'REMOVE_OR_DENY_FRIEND'
export const REMOVE_OR_DENY_FRIEND_LOADING = 'REMOVE_OR_DENY_FRIEND_LOADING'
export const REMOVE_OR_DENY_FRIEND_ERROR = 'REMOVE_OR_DENY_FRIEND_ERROR'
export const REMOVE_OR_DENY_FRIEND_SUCCESS = 'REMOVE_OR_DENY_FRIEND_SUCCESS'

export const FIND_FRIENDS = 'FIND_FRIENDS'
export const FIND_FRIENDS_LOADING = 'FIND_FRIENDS_LOADING'
export const FIND_FRIENDS_SUCCESS = 'FIND_FRIENDS_SUCCESS'
export const FIND_FRIENDS_ERROR = 'FIND_FRIENDS_ERROR'

export const FETCH_PENDING_FRIEND_REQUESTS = 'FETCH_PENDING_FRIEND_REQUESTS'
export const FETCH_PENDING_FRIEND_REQUESTS_LOADING = 'FETCH_PENDING_FRIEND_REQUESTS_LOADING'
export const FETCH_PENDING_FRIEND_REQUESTS_SUCCESS = 'FETCH_PENDING_FRIEND_REQUESTS_SUCCESS'
export const FETCH_PENDING_FRIEND_REQUESTS_ERROR = 'FETCH_PENDING_FRIEND_REQUESTS_ERROR'

export const ADD_FRIEND = 'ADD_FRIEND'
export const ADD_FRIEND_LOADING = 'ADD_FRIEND_LOADING'
export const ADD_FRIEND_SUCCESS = 'ADD_FRIEND_SUCCESS'
export const ADD_FRIEND_ERROR = 'ADD_FRIEND_ERROR'

export const FETCH_SUGGESTED_FRIENDS = 'FETCH_SUGGESTED_FRIENDS'
export const FETCH_SUGGESTED_FRIENDS_LOADING = 'FETCH_SUGGESTED_FRIENDS_LOADING'
export const FETCH_SUGGESTED_FRIENDS_SUCCESS = 'FETCH_SUGGESTED_FRIENDS_SUCCESS'
export const FETCH_SUGGESTED_FRIENDS_ERROR = 'FETCH_SUGGESTED_FRIENDS_ERROR'

export const FETCH_MORE_SUGGESTED_FRIENDS = 'FETCH_MORE_SUGGESTED_FRIENDS'
export const FETCH_MORE_SUGGESTED_FRIENDS_LOADING = 'FETCH_MORE_SUGGESTED_FRIENDS_LOADING'
export const FETCH_MORE_SUGGESTED_FRIENDS_SUCCESS = 'FETCH_MORE_SUGGESTED_FRIENDS_SUCCESS'
export const FETCH_MORE_SUGGESTED_FRIENDS_ERROR = 'FETCH_MORE_SUGGESTED_FRIENDS_ERROR'

export const SEARCH_USERS = 'SEARCH_USERS'
export const SEARCH_USERS_LOADING = 'SEARCH_USERS_LOADING'
export const SEARCH_USERS_SUCCESS = 'SEARCH_USERS_SUCCESS'
export const SEARCH_USERS_ERROR = 'SEARCH_USERS_ERROR'

export const RESET_FRIEND_API_OFFSETS = 'RESET_FRIEND_API_OFFSETS'

export const INVITE_FB_FRIENDS = 'INVITE_FB_FRIENDS'



// WEBPACK FOOTER //
// ./src/services/friends/constants.js